import { render, staticRenderFns } from "./security_sensitive_word.vue?vue&type=template&id=7a9dab95&scoped=true"
import script from "./security_sensitive_word.vue?vue&type=script&lang=js"
export * from "./security_sensitive_word.vue?vue&type=script&lang=js"
import style0 from "./security_sensitive_word.vue?vue&type=style&index=0&id=7a9dab95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9dab95",
  null
  
)

export default component.exports